import React, { useEffect, useState } from 'react';
import { getUsers, reassignOverdue } from '../../lib/api';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';
import { toast } from 'sonner';

export const ReassignDialog = ({ open, onOpenChange, dossierId, currentCommercialId, onDone }) => {
    const [users, setUsers] = useState([]);
    const [selectedId, setSelectedId] = useState('');
    const [busy, setBusy] = useState(false);

    useEffect(() => {
        if (!open) return;
        (async () => {
            try {
                const res = await getUsers();
                const commercials = (res.data || []).filter((u) => u.role === 'commercial' || u.role === 'manager');
                setUsers(commercials);
                setSelectedId('');
            } catch {
                setUsers([]);
            }
        })();
    }, [open]);

    const handleConfirm = async () => {
        if (!selectedId) {
            toast.error('Sélectionnez un commercial');
            return;
        }
        if (selectedId === currentCommercialId) {
            toast.error('Le dossier est déjà assigné à ce commercial');
            return;
        }
        setBusy(true);
        try {
            await reassignOverdue(dossierId, selectedId);
            toast.success('Dossier réassigné');
            onOpenChange(false);
            onDone && onDone();
        } catch (e) {
            toast.error(e.response?.data?.detail || 'Erreur');
        } finally {
            setBusy(false);
        }
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent data-testid="reassign-dialog">
                <DialogHeader>
                    <DialogTitle>Réassigner le dossier</DialogTitle>
                </DialogHeader>
                <div className="space-y-3">
                    <Label className="field-label">Nouveau commercial</Label>
                    <Select value={selectedId} onValueChange={setSelectedId}>
                        <SelectTrigger className="h-10 rounded-sm" data-testid="reassign-select">
                            <SelectValue placeholder="Sélectionner..." />
                        </SelectTrigger>
                        <SelectContent>
                            {users.map((u) => (
                                <SelectItem key={u.id} value={u.id}>
                                    {u.name} {u.id === currentCommercialId ? ' (actuel)' : ''}
                                </SelectItem>
                            ))}
                        </SelectContent>
                    </Select>
                    <p className="text-xs text-[#52525B]">Le prospect associé sera aussi réassigné.</p>
                </div>
                <DialogFooter>
                    <Button variant="outline" onClick={() => onOpenChange(false)}>Annuler</Button>
                    <Button
                        onClick={handleConfirm}
                        disabled={busy}
                        className="bg-[#E85A24] hover:bg-[#CC4D1C] text-white rounded-sm"
                        data-testid="reassign-confirm-btn"
                    >
                        Réassigner
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};
